import { Component, OnInit, OnDestroy, HostListener} from '@angular/core';
import { AARouterURL } from '../../enums/routing.enum';
import { AppRouterDataService } from '../../services/app-router-data/app-router-data.service';
import { AARouteEvents, MobileNavigationEvent } from 'src/app/core/events/events';
import { EventsService } from 'src/app/core/services/events.service';
import { IMobileNavigationEventModel } from 'src/app/core/models/models';
import { AppUtilityService } from 'src/app/core/services/app-utility/app-utility.service';

@Component({
    selector: 'aa-mobile-navigation',
    templateUrl: './mobile-navigation.component.html',
    styleUrls: ['./mobile-navigation.component.scss'],
    standalone: false
})
export class MobileNavigationComponent implements OnInit, OnDestroy {

  public directionMenuLabel = 'Directions';
  public mapsMenuLabel = 'Map';
  public activeStatus: any = {directionLink: true, mapLink: false}; // default state

  public mobileDirectionLink: AARouterURL = AARouterURL.ROUTE_PLANNER;
  public mobileMapLink: AARouterURL = AARouterURL.MOBILE_MAP;

  constructor(private appRouterDataService: AppRouterDataService, private eventsService: EventsService,
    private appUtilityService: AppUtilityService) { }

  ngOnInit() {
    this.mobileDirectionLink = this.appRouterDataService.activeRouteTap;
    this.appRouterDataService.on(AARouteEvents.ROUTE_READY, this.onRouteReady);
    this.eventsService.on(MobileNavigationEvent.SELECT_MOBILE_MENU, this.selectMobileTab);
  }

  ngOnDestroy() {
    this.appRouterDataService.remove(AARouteEvents.ROUTE_READY, this.onRouteReady);
    this.eventsService.remove(MobileNavigationEvent.SELECT_MOBILE_MENU, this.selectMobileTab);
  }

  private onRouteReady = () => {
    this.mobileDirectionLink = this.appRouterDataService.activeRouteTap;

    switch (this.mobileDirectionLink ) {
      case AARouterURL.ROUTE_PLANNER:
        this.directionMenuLabel = 'Directions';
        this.mapsMenuLabel = 'Maps';
        break;
      case AARouterURL.TRAFFIC_NEWS:
        this.directionMenuLabel = 'Search';
        this.mapsMenuLabel = 'Options';
        break;
      case AARouterURL.MAP_HOTELS:
        this.directionMenuLabel = 'Search';
        this.mapsMenuLabel = 'Options';
        break;
    }
  }

  navigateTab(activeTab: AARouterURL): void {
    const data: IMobileNavigationEventModel = {ActivePage: this.mobileDirectionLink, ActiveTab: activeTab};
    this.selectMobileTab(data);
  }

  private selectMobileTab = (event: IMobileNavigationEventModel) => {
    this.selectedTab = event.ActiveTab;
    this.eventsService.dispatch(MobileNavigationEvent.MOBILE_MENU, event);
  }

  set selectedTab(activeTab: AARouterURL) {
    if (activeTab === AARouterURL.MOBILE_MAP) {
      this.activeStatus.mapLink = true;
      this.activeStatus.directionLink = false;
    } else {
      this.activeStatus.mapLink = false;
      this.activeStatus.directionLink = true;
    }
  }

}
